var App = App || {};

App.Login = (function ($) {
    "use strict";

    function initLoginCarousel() {
        var $loginForm = $("form.login-carousel"),
            $accountType = $(".account-type"),
            $selectedOption = $accountType.find(":selected"),
            $loginFields = $loginForm.find(".login-fields"),
            $submitButton = $loginForm.find("button.submit"),
            $submitLink = $loginForm.find("a.submit"),
            $passwordDiv = $loginForm.find("div.password"),
            $usernameDiv = $loginForm.find("div.username"),
            $linksDiv = $loginForm.find("div.loginlinks"),
            selectedOptionValue = $selectedOption.val(),
            selectedOptionTarget = $selectedOption.data("target"),
            selectedOptionClass = $selectedOption.text().toLowerCase().replace(/[\s]+/g, "-");

        $loginForm.attr("action", selectedOptionValue);

        if (selectedOptionTarget === "_blank") {
            $loginForm
                .removeAttr("action")
                .removeAttr("method");

            $submitButton.hide();
            $usernameDiv.hide();
            $passwordDiv.hide();
            $linksDiv.hide();
            $submitLink
                .attr({
                    "href": selectedOptionValue,
                    "target": selectedOptionTarget
                })
                .show();
        } else {
            $loginForm.attr({
                "action": selectedOptionValue,
                "method": "post"
            });

            $submitButton.show();
            $submitLink
                .removeAttr("href")
                .removeAttr("target")
                .hide();
        }

        $accountType.on("change", function () {

            $selectedOption = $(this).find(":selected"),
            selectedOptionValue = $selectedOption.val(),
            selectedOptionTarget = $selectedOption.data("target"),
            selectedOptionClass = $selectedOption.text().toLowerCase().replace(/[\s]+/g, "-");

            $accountType
                .not($(this))
                .each(function () {
                    $(this).val(selectedOptionValue);
                });

            $.each($loginFields, function () {
                var $this = $(this);
                showLoginFields($this);
            });            

            function showLoginFields($this) {
                if ($this.attr("class").indexOf(selectedOptionClass) > 0) {

                    $this.fadeIn("fast");

                    if (selectedOptionTarget === "_blank") {
                        $loginForm
                            .removeAttr("action")
                            .removeAttr("method");

                        $submitButton.hide();
                        $usernameDiv.hide();
                        $passwordDiv.hide();
                        $linksDiv.hide();
                        $submitLink
                            .attr({
                                "href": selectedOptionValue,
                                "target": selectedOptionTarget
                            })
                            .show();
   
                    } else {

                        $loginForm.attr({
                            "action": selectedOptionValue,
                            "method": "post"
                        });

                        $loginForm.find("div.initial-submit").hide();
                        $loginForm.find("button.submit.initial-submit").hide();
                        $submitButton.not(".initial-submit").show();
                        $usernameDiv.show();
                        $passwordDiv.show();
                        $linksDiv.show();
                        $submitLink
                            .removeAttr("href")
                            .removeAttr("target")
                            .hide();
                    }
                    
                } else {

                    //$this.hide();
                }
            }
        });
    }

    function initLoginDropdown() {
        var $loginForm = $("form.login-dropdown"),
            $accountType = $(".account-type"),
            $selectedOption = $accountType.find(":selected"),
            $loginFields = $loginForm.find(".login-fields"),
            $submitButton = $loginForm.find("button.submit"),
            $submitLink = $loginForm.find("a.submit"),
            $passwordDiv = $loginForm.find("div.password"),
            $usernameDiv = $loginForm.find("div.username"),
            $linksDiv = $loginForm.find("div.loginlinks"),
            selectedOptionValue = $selectedOption.val(),
            selectedOptionTarget = $selectedOption.data("target"),
            selectedOptionClass = $selectedOption.text().toLowerCase().replace(/[\s]+/g, "-");

        $loginForm.attr("action", selectedOptionValue);

        if (selectedOptionTarget === "_blank") {
            $loginForm
                .removeAttr("action")
                .removeAttr("method");

            $submitButton.hide();
            $usernameDiv.hide();
            $passwordDiv.hide();
            $linksDiv.hide();
            $submitLink
                .attr({
                    "href": selectedOptionValue,
                    "target": selectedOptionTarget
                })
                .show();
        } else {
            $loginForm.attr({
                "action": selectedOptionValue,
                "method": "post"
            });

            $submitButton.show();
            $submitLink
                .removeAttr("href")
                .removeAttr("target")
                .hide();
        }

        $accountType.on("change", function () {

            $selectedOption = $(this).find(":selected"),
                selectedOptionValue = $selectedOption.val(),
                selectedOptionTarget = $selectedOption.data("target"),
                selectedOptionClass = $selectedOption.text().toLowerCase().replace(/[\s]+/g, "-");

            $accountType
                .not($(this))
                .each(function () {
                    $(this).val(selectedOptionValue);
                });

            $.each($loginFields, function () {
                var $this = $(this);
                showLoginFields($this);
            });

            function showLoginFields($this) {

                if ($this.attr("class").indexOf(selectedOptionClass) > 0) {

                    $this.fadeIn("fast");

                    if (selectedOptionTarget === "_blank") {
                        $loginForm
                            .removeAttr("action")
                            .removeAttr("method");

                        $submitButton.hide();
                        $usernameDiv.hide();
                        $passwordDiv.hide();
                        $linksDiv.hide();
                        $submitLink
                            .attr({
                                "href": selectedOptionValue,
                                "target": selectedOptionTarget
                            })
                            .show();

                    } else {

                        $loginForm.attr({
                            "action": selectedOptionValue,
                            "method": "post"
                        });

                        $loginForm.find(".login-fields.initial").show();
                        $loginForm.find(".login-fields").not(".initial").hide();


                        $submitButton.show();
                        $usernameDiv.show();
                        $passwordDiv.show();
                        $linksDiv.show();
                        $submitLink
                            .removeAttr("href")
                            .removeAttr("target")
                            .hide();
                    }

                } else {  
                    $this.hide();
                }
            }
        });
    }

    return {
        initLoginCarousel: initLoginCarousel,
        initLoginDropdown: initLoginDropdown
    };

})(jQuery);

$(function () {
    App.Login.initLoginCarousel();
    App.Login.initLoginDropdown();
});